import { render, staticRenderFns } from "./agentItem.vue?vue&type=template&id=24dbb56c&scoped=true"
import script from "./agentItem.vue?vue&type=script&lang=js"
export * from "./agentItem.vue?vue&type=script&lang=js"
import style0 from "./agentItem.vue?vue&type=style&index=0&id=24dbb56c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24dbb56c",
  null
  
)

export default component.exports